import styled, { css } from "styled-components/macro";

const Button = styled.button<{ comingSoon?: any }>`
  border: none;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  width: 100%;
  height: 100%;
  background-color: inherit;

  &:hover {
    background-color: ${(props) => props.theme.colors.pastelLilac};
    cursor: ${(props) => (props.comingSoon ? "auto" : "pointer")};
  }

  &:focus {
    outline: none;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.largeScreen}) {
    width: 100%;
    justify-content: space-between;
    height: 6rem;
  }
`;

const Main = styled.span<{ comingSoon?: any; isOpen?: any }>`
  & a {
    text-decoration: none;
    color: ${(props) => props.theme.colors.primary};
  }

  border: none;
  background-color: inherit;
  color: ${(props) => {
    if (props.comingSoon) {
      return props.theme.colors.colorLightGrayBlue;
    } else if (props.isOpen) {
      return props.theme.colors.primary;
    } else {
      return props.theme.colors.colorGrayDark;
    }
  }};
  font-size: 16px;
  // font-weight: 500;
  text-decoration: none;
  font-family: ${(props) => props.theme.fontStyles.subHeading};

  &:hover {
    ${(props) =>
      props.comingSoon
        ? css`
            color: ${(props) => props.theme.colors.colorLightGrayBlue};
          `
        : css<{ isOpen?: any }>`
            color: ${(props) =>
              props.isOpen
                ? props.theme.colors.primary
                : props.theme.colors.lightPurple};
          `}
  }
`;

const MainLink = styled.span`
  display: block;
  width: 100%;
  & a {
    display: block;
    text-decoration: none;
    width: 100%;
    padding: 15px;
    font-family: ${(props) => props.theme.fontStyles.subHeading};
    color: ${(props) => props.theme.colors.primary};

    &:hover {
      background-color: ${(props) => props.theme.colors.pastelLilac};
    }
  }
`;

export { Main, MainLink, Button };
